import React, { useEffect, useState } from 'react'
import InquiryModal from '../components/InquiryModal'
import AnimatedStat from '../components/AnimatedStat'

export default function AboutPage() {
  const [modalOpen, setModalOpen] = useState(false)

  useEffect(() => {
    document.title = 'Om SKI & CO TRAVEL - SKI & CO TRAVEL ApS'
  }, [])

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 space-y-12">
      {/* Header section */}
      <div className="space-y-3 max-w-3xl">
        <span className="text-xs font-bold uppercase tracking-widest text-cyan-400">
          OM SKI & CO TRAVEL
        </span>
        <h1 className="font-heading font-extrabold text-2xl sm:text-4xl text-white">
          Grundlagt af en ivrig skiløber. Bygget til erhvervslivet.
        </h1>
        <p className="text-slate-300 text-base sm:text-lg leading-relaxed">
          Ski & Co Travel blev grundlagt i 2014 af Claus Nexø Hansen — ivrig skiløber gennem 25 år og tidligere salgschef/salgsdirektør.
        </p>
      </div>

      {/* Main content grid with photo moved up */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
        {/* Photo Container - placed first in DOM order so on mobile it sits directly above the full story */}
        <div className="lg:col-span-5 order-first lg:order-last">
          <div className="relative rounded-3xl overflow-hidden border border-slate-800 shadow-2xl bg-slate-900 sticky top-28">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/9bff8fd4-e9da-49ba-96b9-18c20ed7b396/im1.jpeg"
              alt="Claus Nexø Hansen og teamet bag Ski & Co Travel."
              className="w-full h-[360px] sm:h-[420px] object-cover object-top"
            />
            <div className="p-4 bg-slate-950 border-t border-slate-800 text-center">
              <p className="text-xs font-medium text-slate-300">
                Claus Nexø Hansen og teamet bag Ski & Co Travel.
              </p>
            </div>
          </div>
        </div>

        {/* Text story and stats */}
        <div className="lg:col-span-7 bg-slate-900 border border-slate-800 rounded-3xl p-6 sm:p-10 space-y-6 shadow-2xl">
          <div className="space-y-4 text-slate-300 text-sm sm:text-base leading-relaxed">
            <p>
              Ski & Co Travel blev grundlagt i 2014 af Claus Nexø Hansen — ivrig skiløber gennem 25 år og tidligere salgschef/salgsdirektør. I de roller stod han selv for at arrangere firmaers B2B-skiferier for deres kunder, og den erfaring er nu fundamentet for de rejser, vi sætter sammen til jer.
            </p>
            <p>
              Vi holder til i hele Alperne — Østrig, Frankrig og Italien — men har naturligvis vores egne favoritter, som vi vender tilbage til år efter år.
            </p>
            <p>
              Alt kan skræddersys: transport med bus, fly eller kør-selv, indkvartering på 5-stjernede hoteller eller lejligheder med morgenmad, gourmetrestauranter samt salgscoaches eller foredragsholdere. I bestemmer indhold og prioritet — vi sørger for, at det hænger sammen.
            </p>
          </div>

          {/* Animated Stats Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 pt-4 border-t border-slate-800">
            <AnimatedStat value="2014" label="Grundlagt" />
            <AnimatedStat value="3" label="Lande i Alperne" />
            <AnimatedStat value="35+" label="År på ski" />
            <AnimatedStat value="100%" label="Skræddersyet" />
          </div>

          <div className="pt-4 border-t border-slate-800 flex flex-wrap gap-4">
            <button
              onClick={() => setModalOpen(true)}
              className="px-6 py-3 rounded-xl bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-bold text-sm transition-colors shadow-lg shadow-cyan-500/20"
            >
              Send os en forespørgsel
            </button>
            <a
              href="tel:+4551589452"
              className="px-6 py-3 rounded-xl bg-slate-800 hover:bg-slate-700 text-white font-semibold text-sm transition-colors border border-slate-700 inline-flex items-center gap-2"
            >
              <i className="fa-solid fa-phone text-cyan-400" aria-hidden="true" />
              <span>Ring +45 51 58 94 52</span>
            </a>
          </div>
        </div>
      </div>

      <InquiryModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </div>
  )
}
